import axios from '../axios'
import qs from 'qs';

/* 
 * 菜单管理模块
 */

// 创建
export const add = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/menu/add',
        method: 'post',
        data
    })
}
// 查询
export const menuQuery = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/menu/menuQuery',
        method: 'post',
        data
    })
}
// 修改
export const update = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/menu/update',
        method: 'post',
        data
    })
}
// 删除
export const del = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/menu/delete',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/menu.js